import apiClient from "./client";

/** Internet / DVPL plans with sub plans (super admin: base price; others: their own price). */
export const broadbandPlans = (type) =>
  apiClient.get(type === "dvpl" ? "/get_dvpl_plans_with_subplans.php" : "/get_internet_plans_with_subplans.php");
/** RailTel plans (super admin: base price; others: their own price). */
export const railtelPlans = () => apiClient.get("/get_railtel_plans.php");
/** Pioneer IPTV DPOs + add-ons this account sells. */
export const myPioneerPacks = () => apiClient.get("/customer/pioneeriptv/pioneer_my_packs.php");
/** Combos this account sells, at its price. */
export const myCombos = () => apiClient.get("/customer/combo/combo_my.php");
